import React, { useState, useEffect } from "react";
import "./HeaderPage.css";
import {
  Navbar,
  Nav,
  Dropdown,
  Modal,
 } from "react-bootstrap";
import cart_bucket from "../../../assets/cart_bucket.svg";
import dashboard from "../../../assets/dashboards.svg";
import Setting from "../../../assets/settings.svg"; 
import switch_off from "../../../assets/switch_off.svg";
import english from "../../../assets/english.webp";
import tarkish from "../../../assets/tarkish.webp";
import chat_icon from "../../../assets/chat_icon.svg";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import storage from "redux-persist/lib/storage";
import { fetchLogindata, setStoreIpAddress } from "../../login/redux/actions";
import { useNavigate } from "react-router-dom";
import { currentLocationInfo } from "../../home/redux/actions";
import { fetchStoredetail } from "../../dashboard/redux/actions";
import profileDefault from "../../../assets/profile_default.png";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { fetchChangeLanguage } from "../redux/actions";
import { maintainCartdata } from "../../home/redux/actions";
import { storeCategories } from "../../home/redux/actions";
import { storeServices } from "../../home/redux/actions";
import {
  fetchChatuserlist,
  storeChathistory,
} from "../../header/redux/actions";
import { storeConnection } from "../../header/redux/actions";
import { logOutAPI } from "../../login/util/logout";
import down_circle from "../../../assets/down_circle.svg";
import { getRequestcall } from "../../comman/util/getRequest";
import { MY_CHAT_LIST, SERVICES, UPDATE_LANGUAGE } from "../../constants/apiurl";
import { postRequestcall } from "../../comman/util/postRequest";
import PlacesAutocompletePage from "../../comman/components/PlaceautocompletePage";
import ButtonPage from "../../comman/button/ButtonPage";
import mob_cart_icon from "../../../assets/mob_cart_icon.svg";
import down_arrow_header from "../../../assets/down_arrow_header.svg";
import { setStoreMessageReceived } from "../../chat/redux/actions";

function HeaderPage(props) {
  const [scroll, setScroll] = useState(false);
  const [address, setAddress] = useState("");
  const [placaddress, setPlaceaddress] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [shownavbar,setShownavbar] = useState(false);
  let currentUrl = window.location.pathname.split("/").pop();
  let background = "white";
  window.onscroll = function () {
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  useEffect(() => {
    //set address and type at header from redux when useEffect call
    setPlaceaddress(props.currentLocation.selectedLocation);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    changeChange(props.language);
    // eslint-disable-next-line
  }, [!props.language]);

  const changeChange = (e) => {
    props.fetchChangeLanguage(e);
    i18next.changeLanguage(e);
  };

  const callLogout = async () => {
    const responceLogout = await logOutAPI(props?.access_token);
    if (responceLogout !== null) {
      if (responceLogout?.status === 200) {
        clearReduxdata();
      } else if (responceLogout?.status === 302) {
        clearReduxdata();
      } else {
        clearReduxdata();
      }
    } else {
      clearReduxdata();
    }
  };

  const clearReduxdata = () => {
    dispatch(setStoreIpAddress(""));
    navigate("/");
    setShownavbar(false);
    props.fetchLogindata({});
    props.fetchStoredetail([]);
    props.maintainCartdata([], {});
    //props.currentLocationInfo({});
    props.fetchChatuserlist([]);
    props.storeConnection({});
    setPlaceaddress("");
    dispatch(setStoreMessageReceived({messages:[], users_id:""}))
    storage.removeItem("persist:persist-store");
  };

  const callDashboard = () => {
    if (props.type === "vendor") {
      navigate("/vendor/dashboard");
    } else {
      navigate("/user/dashboard");
    }
    setShownavbar(false);
  };

  const redirectTovendorsignup = () => {
    setShownavbar(false);
    if (props.type === "user") {
      navigate("/business-setup");
    } else {
      navigate("/partner");
    }
  };

  const Changelanguage =async (language) => {
    if(props?.access_token){
      const payload = {
        language:language?.toLowerCase()
      }
      await  postRequestcall(UPDATE_LANGUAGE, props?.access_token, payload);
      // const result = await respo?.json();
      // console.log("result",result)
    }
    localStorage.setItem("language", language);
    props.fetchChangeLanguage(language);
    i18next.changeLanguage(language);
    updateCategory(language);
  };

  const updateCategory = async (language) => {
    callService(language);
  };

  const callService = async (language) => {
    let getserviceurl = SERVICES + `?lang=${language.toLowerCase()}`;
    let getCategories = await getRequestcall(getserviceurl, "");
    if (getCategories?.status === 200) {
      let data = await getCategories.json();
      let value = {};
      let getAll = [];
      let getCheck = [];
      if(typeof props?.categories !== "undefined") {
          getCheck =  props?.categories?.filter((item)=>item?.is_checked===true);
      }
      data?.data?.forEach((item) => {
        let is_checked = false;
        if(getCheck?.length > 0) {
           if(getCheck.filter((value)=>value?.id === item?.id).length > 0){
             is_checked = true;
           }
        }
        value = {
          id: item.id,
          image: item.image,
          image_url: item.image_url,
          sid: item.sid,
          web_image_url: item?.web_image_url,
          title: item.title,
          type: item.type,
          is_checked: is_checked,
          list: [],
        };
        getAll.push(value);
      });
      let getService = getAll.filter((item) => item.type === "service");
      props.storeServices(getService);
      props.storeCategories(getAll);
    }
  };

  const navigateTocart = () => {
    navigate("/cart");
    setShownavbar(false);
  };

  const callSetting = () => {
    setShownavbar(false);
    if (props?.type === "vendor") {
      navigate("/vendor/settings");
    } else {
      navigate("/user/settings");
    }
  };

  
 
  const redirectTologin = () => {
    setShownavbar(false);
    navigate("/login");
  };

  const gotoChat = async (e) => {
    e.preventDefault();
    dispatch(setStoreMessageReceived({messages:[], users_id:""}))
    let getList = await postRequestcall(MY_CHAT_LIST, props?.access_token, "");
    if (getList?.status === 200) {
      let getres = await getList.json();
      if (getres?.data?.chat_list?.length > 0) {
        navigate(`/chat/${getres?.data?.chat_list[0].user_detail?.jid}`);
      }
    } else {
      navigate(`/chat/no-chat`);
    }
    setShownavbar(false);
  };

  const updateCount = (cartdata) => {
    let updateCartcount = [];
    cartdata.forEach((item) => {
      if (
        item?.product_deleted_at === null &&
        item?.out_of_stock === false &&
        item.variation_deleted_at === null
      ) {
        updateCartcount.push(item);
      }
    });
    return updateCartcount.length;
  };

  const navigateTooffer = () => {
    var timestamp = new Date().getTime();
    navigate("/offers", { state: { obj: timestamp } });
    setShownavbar(false);
  };

  // const displayNavbar = () => {
  //     setShownavbar(true)
  // }

  // const hideNavbar = (e) =>{
  //    e.preventDefault();
  //    setShownavbar(false);
  // }

  const showContent = (e) => {
    e.preventDefault();
      if(shownavbar){
         setShownavbar(false);
      }
      else{
         setShownavbar(true)
      }
  }

  const authRedireaction = () => {
     return(
      !props.access_token && (
        <>
            <Link to="/login"
            className="pe-4 nav-link"
            style={{
              paddingBottom: "0px",
              display: currentUrl === "partner" ? "none" : "",
            }}
            onClick={(e)=>setShownavbar(false)}
            >
              <h6 className="menu">{t("pages.header.login")}</h6>
            </Link>

            <Link to="/signup" 
            className="pe-4 nav-link"
            style={{
              paddingBottom: "0px",
              display: currentUrl === "partner" ? "none" : "",
            }}
            onClick={(e)=>setShownavbar(false)}
            >
              <h6 className="menu">{t("pages.header.signup")}</h6>
            </Link>
        </>
      )
     )
  }

  const offerRedireaction = () => {
      return(
        currentUrl !== "partner" && (
          <>
            <Nav.Link
              onClick={() => navigateTooffer()}
              className="pe-4"
              style={{ paddingBottom: "0px" }}
            >
              <h6 className="menu">{t("pages.header.offer")}</h6>
            </Nav.Link>
          </>
        )
      )
  }

  const becompartnerRedireaction = () =>{
    return(
      props.type === "user" || !props.access_token) && (
        <Nav.Link
          className="pe-3"
          style={{
            display: currentUrl === "partner" ? "none" : "",
          }}
        >
          <ButtonPage
            className="btnbecome"
            onClick={() => redirectTovendorsignup()}
            Text={t("pages.header.become_partner")}
          />
        </Nav.Link>
      )
    
  }

  const vendorloginRedireaction = () => {
    return (
      currentUrl === "partner" && ( 
        <Nav.Link className="pe-3">
          <ButtonPage
            className="btnbecome"
            onClick={() => redirectTologin()}
            Text={t("pages.header.vendor_login")}
          />
        </Nav.Link>
       )
    )
  }

  const settingRedireaction = () => {
     return (
      props.access_token && (
        <Nav.Link>
          <Dropdown className="setting-dropdown">
            <Dropdown.Toggle variant="success" id="dashboard_dropdown">
              {props?.logindata?.image_url ? (
                <img
                  alt="user_image"
                  className="user-img"
                  height="40"
                  width="40"
                  onError={(event) =>
                    (event.target.src = profileDefault)
                  }
                  src={props?.logindata?.image_url}
                />
              ) : (
                <img
                  alt="user_image"
                  height="40"
                  width="40"
                  className="user-img"
                  src={profileDefault}
                />
              )}{" "}
              <img
                src={down_circle}
                alt={"arrow"}
                height="15"
                width="15"
              ></img>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => callDashboard()}>
                <img alt={"dashboard"} src={dashboard} />{" "}
                {t("pages.header.dashboard")}
              </Dropdown.Item>
              <Dropdown.Item onClick={(e) => gotoChat(e)}>
                <img alt={"chat"} src={chat_icon} />{" "}
                {t("pages.header.chat")}
              </Dropdown.Item>
              <Dropdown.Item onClick={() => callSetting()}>
                <img alt={"setting"} src={Setting} />{" "}
                {t("pages.header.setting")}
              </Dropdown.Item>
              <Dropdown.Item onClick={() => callLogout()}>
                <img alt={"logout"} src={switch_off} />{" "}
                {t("pages.header.logout")}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav.Link>
      )
     )
  }

  const languageRedirect = () => {
    return(
      <Dropdown id="menu-drop" className="menu-drop language_dropdown">
      <Dropdown.Toggle variant="success">
        <img
          src={props?.language === "Tr" ? tarkish : english}
          alt={"language"}
          className={"me-2"}
        ></img>
        {props?.language}
        <img src={down_arrow_header} className={"down_arrow_lng"} alt={"arrow"} />
      </Dropdown.Toggle>
      <Dropdown.Menu className="drop-menus">
        <Dropdown.Header>
          {t("pages.header.select_language")}
        </Dropdown.Header>
        <Dropdown.Item onClick={() => Changelanguage("En")}>
          <img src={english} alt={"English"} className={"me-1"}></img>{" "}
          {t("pages.header.english")}
        
        </Dropdown.Item>
        <Dropdown.Item onClick={() => Changelanguage("Tr")}>
          <img src={tarkish} alt={"Turkish"} className={"me-1"}></img>{" "}
          {t("pages.header.turkish")}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
    )
  }


  const mobileHeaderclose = () => {
     setShownavbar(false);
  }

  const mobileHeader = () => {
     return (
      <Modal
      size="lg"
      show={shownavbar}
      className="mobile-header"
      onHide={()=>mobileHeaderclose()}
   >
      <Modal.Header closeButton>
         <div className="position-relative count-box">
         <img alt="" src={mob_cart_icon} onClick={() => navigateTocart()}/>
          <span className="cart-count" onClick={() => navigateTocart()}>
           {updateCount(props?.cartdata)} 
          </span>
         </div>
      </Modal.Header>
     <Modal.Body>
     <Nav className="align-items-center text-center">
       {offerRedireaction()}
       {authRedireaction()}
       {becompartnerRedireaction()}
       {vendorloginRedireaction()}
       {settingRedireaction()}
    </Nav>
     </Modal.Body>
      </Modal>
     )
  }
   
  return (
    <>
      <div className={scroll ? "header" : props.headerBackground === "transparent" ? currentUrl === "contact-us" || currentUrl === "partner" ? "header white-text" : "header" : "header"}>
        <Navbar bg={scroll ? background : props.headerBackground} expand="lg">
            <Link to="/">
            <Navbar.Brand className="d-flex">
              <i className="haader_logo" />
            </Navbar.Brand>
          </Link>
          {/* Change location for mobile */}
           <div className="location_mobile">
           <PlacesAutocompletePage setAddress={setAddress} address={address} placaddress={placaddress} setPlaceaddress={setPlaceaddress}/>
          </div>
          <div className="mobile-lang">
          {languageRedirect()}
          </div>
           <div className="navbar-toggler-icon" onClick={(e)=>showContent(e)}/>
             {/* <Navbar.Toggle aria-controls="basic-navbar-nav"/>  */}
            {mobileHeader(shownavbar)}
            <Navbar.Collapse style={shownavbar ? { display:"block"} : {display:"none"}} hidden>
              <Nav>
                <div className="pe-4 location-btn">
                  <PlacesAutocompletePage setAddress={setAddress} address={address} placaddress={placaddress} setPlaceaddress={setPlaceaddress}/>
                </div>
               {languageRedirect()}
               {offerRedireaction()}
               {authRedireaction()}
               {becompartnerRedireaction()}
               {vendorloginRedireaction()}
                {currentUrl !== "partner" && (
                  <Nav.Link className="pe-4">
                    <div className="bucket-div" onClick={() => navigateTocart()}>
                      <img
                        alt="bucket_img"
                        className="bucket-img"
                        width="25"
                        height="25"
                        src={cart_bucket}
                      ></img>
                      <div>
                        {props?.cartdata?.length === 0 ? (
                          <div className="bucket-content">
                            {t("pages.mycart")}
                          </div>
                        ) : (
                          <>
                            <div className="bucket-content">
                              {updateCount(props?.cartdata)} {t("pages.items")}
                            </div>
                            <div className="bucket-content">
                              {Number(
                                typeof props?.amount?.total_amount === "undefined"
                                  ? "00.00"
                                  : props?.amount?.total_amount +
                                      (typeof props?.amount?.charges ===
                                      "undefined"
                                        ? 0
                                        : props?.amount?.charges) -
                                      (typeof props?.amount?.discount ===
                                      "undefined"
                                        ? 0
                                        : props?.amount?.discount)
                              ).toFixed(2)}
                              {process.env.REACT_APP_CURRENCY_SYMBOL}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </Nav.Link>
                )}
              {settingRedireaction()}
              </Nav>
            </Navbar.Collapse>
         </Navbar>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  type: state?.login.type,
  currentLocation: state?.home?.currentLocation,
  logindata: state?.login?.logindata,
  language: state?.languageState?.language,
  cartdata: state?.home?.cartdata,
  amount: state?.home?.amount,
  xmppclient: state?.languageState?.xmppclient,
});

export default connect(mapStateToProps, {
  fetchLogindata,
  fetchStoredetail,
  currentLocationInfo,
  fetchChangeLanguage,
  maintainCartdata,
  storeCategories,
  storeServices,
  fetchChatuserlist,
  storeChathistory,
  storeConnection,
})(HeaderPage);
